import 'reflect-metadata';

import { Container } from 'inversify';

import { InversifyContainer } from '../../shared/abstract/infrastructrue/Inversify.container';
import {
  SpecificUserQuery,
  UserCreatorCommand,
  UserTenantAgnosticUnifiedRolesQuery,
  UserTenantAgnosticUnifiedRolesUpdateCommand,
  UserTenantSpecificTenantAdminPolicyUpdateCommand,
  UserTenantSpecificUnifiedRolesQuery,
  UserTenantSpecificUnifiedRolesUpdateCommand,
} from './application/useCase';
import { UserHookService } from './application/User.hook.service';
import { UserService } from './application/User.service';
import { UserUIService } from './application/User.ui.service';
import { UserFormResolver } from './domain/forms/UserForm.resolver';
import { UserServiceClientAdapter } from './infrastructure/adapters/UserServiceClient.adapter';
import { UserHookController } from './infrastructure/controllers/User.hook.controller';
import { UserServiceController } from './infrastructure/controllers/User.service.controller';
import { UserComponentFactory } from './infrastructure/factories/User.component.factory';
import { UserFactory } from './infrastructure/factories/User.factory';
import { UserHookFactory } from './infrastructure/factories/User.hook.factory';
import { UserUIServicePort } from './infrastructure/ports/User.ui.service.port';

export class UserDomainContainer extends InversifyContainer {
  static create(): Container {
    return this.buildInversifyIOCContainer([
      UserFormResolver,
      UserUIService,
      UserHookService,
      UserHookController,
      UserHookFactory,
      UserServiceController,
      UserTenantSpecificTenantAdminPolicyUpdateCommand,
      UserComponentFactory,
      UserServiceClientAdapter,
      UserFactory,
      UserService,
      UserTenantAgnosticUnifiedRolesQuery,
      UserTenantAgnosticUnifiedRolesUpdateCommand,
      UserTenantSpecificUnifiedRolesQuery,
      UserTenantSpecificUnifiedRolesUpdateCommand,
      UserCreatorCommand,
      SpecificUserQuery,
      UserUIServicePort,
    ]);
  }
}
